module.exports = __webpack_public_path__ + "img/clip.d82ba444.svg";